'use client'

import { lazy, Suspense } from 'react'
import { Modal } from '@wiggui/ds/Modal'
import { Button } from '@wiggui/ds/Button'
import { MdElectricBolt, MdOutlineOpenInNew } from 'react-icons/md'
import { useMatchWindowQuery } from '../../../../hooks/ds/useMatchWindowQuery'
import { useWelcomeWiggot } from './useWelcomeWiggot'

import Flex from '@wiggui/ds/Flex'
import Text from '@wiggui/ds/Text'
import Divider from '@wiggui/ds/Divider'

const SvgWelcomeWiggot = lazy(() => import('./svg/SvgContainerWelcome'))

const SvgRowWelcomeWiggot = lazy(
  () => import('./svg/SvgRowContainerWelcomeWigot')
)

export const ModalWelcomeWiggot = () => {
  const { isMD } = useMatchWindowQuery()
  const { isOpen, handleActiveTrialPlan, goToShop } = useWelcomeWiggot()

  return (
    <Modal
      buttomSheetClassName="!bg-surface-dark relative pb-5"
      className="w-full max-w-[646px] relative !bg-surface-bg-black !border-transparent !p-0 h-full max-h-[447px] flex flex-col md:!flex-row items-center justify-center gap-2"
      enableBgBlur
      isOpen={isOpen}
    >
      <div className="w-full md:max-w-[50%] bg-surface-bg-black md:h-full md:rounded-l-xl md:flex md:items-stretch md:justify-start rounded-l-xl">
        {isMD && (
          <Suspense>
            <SvgWelcomeWiggot />
          </Suspense>
        )}
        {!isMD && (
          <Suspense>
            <SvgRowWelcomeWiggot />
          </Suspense>
        )}
      </div>

      <Flex
        dir="col"
        gap="gap-6"
        items="center"
        justify="center"
        className="w-full pt-4 md:pt-0 bg-surface-bg-black md:bg-transparent md:max-w-[50%] h-full px-6"
      >
        <Flex dir="col" items="center" justify="center" gap="gap-6" wFull>
          <Flex dir="col" items="start" justify="center" gap="gap-3" wFull>
            <p className="text-[12px] w-full font-extrabold leading-normal text-left text-secondary uppercase">
              Te damos la bienvenida a Wiggot
            </p>
            <p className="text-white text-left text-headline-s">
              Obtén más prospectos, vende más y colabora mejor. Cumple tus metas
              profesionales.
            </p>
          </Flex>
          <Flex
            dir="col"
            className="rounded-xl bg-overlay-white p-2"
            items="center"
            justify="start"
            gap="gap-2"
            wFull
          >
            <Flex dir="row" items="center" justify="start" gap="gap-2" wFull>
              <Flex
                items="center"
                justify="center"
                className="min-w-[40px] bg-[#FEF6E6] rounded-lg w-10 h-10"
              >
                <Flex
                  items="center"
                  justify="center"
                  className="rounded-full w-[20px] h-[20px] bg-notif-yellow"
                >
                  <MdElectricBolt className="text-white min-w-[16px] min-h-[16px]" />
                </Flex>
              </Flex>
              <Text className="text-white text-body-s font-normal">
                Tu periodo de prueba del Plan Avanzado es de 7 días
              </Text>
            </Flex>
            <Divider />
            <Flex
              wFull
              dir="row"
              items="center"
              onClick={goToShop}
              justify="between"
              gap="gap-3"
              as="button"
              className="group active:brightness-75"
            >
              <p className="text-terciary font-normal group-hover:underline text-body-xs">
                Conoce aquí todos los beneficios
              </p>
              <MdOutlineOpenInNew className="text-terciary group-hover:brightness-110 min-w-[12px] min-h-[12px]" />
            </Flex>
          </Flex>
        </Flex>
        <Flex
          dir="col"
          items="center"
          justify="center"
          gap="gap-3"
          wFull
          className="pb-5 md:pb-0"
        >
          <Button
            type="button"
            fullWidth
            onClick={handleActiveTrialPlan}
            variant="primary"
          >
            Comenzar
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}
